export const AudioPluginID = 'audio';
